import { actionTypes } from './actions';

const initialState = {
  loading: false,
  error: false,
  data: null,
  years: null,
};

export default function calendarEventsReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.EVENTS_BY_YEAR_START:
      return { ...state, loading: true, error: null };
    case actionTypes.EVENTS_BY_YEAR_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case actionTypes.YEARS_LIST_SUCCESS:
      return { ...state, years: action.payload };
    case actionTypes.EVENTS_BY_YEAR_FAILURE:
    case actionTypes.YEARS_LIST_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}
